import { Box, CircularProgress, DialogContentText } from "@mui/material"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import { useFormik } from "formik"
import { useAppDispatch } from "hooks"
import { useState } from "react"
import simulatorApplicationService from "services/simulatorApplicationService"
import { addSimulatorApplication } from "slices/simulatorApplicationSlice"
import type { ICreateSimulatorApplication } from "types/simulatorApplicationTypes"
import * as Yup from "yup"

export function CreateSimulatorApplicationDialog() {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [open, setOpen] = useState(false)

  const dispatch = useAppDispatch()

  const initialValues: ICreateSimulatorApplication = {
    name: "",
    id: "",
  }

  const createSimulatorApplicationValidationScheme = Yup.object({
    name: Yup.string()
      .required("Please enter application name")
      .max(64, "Maximum name length is 64 characters"),
  })

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: createSimulatorApplicationValidationScheme,
    onSubmit: (values) => {
      setIsLoading(true)

      const newSimulatorApplication: ICreateSimulatorApplication = {
        name: values.name,
        id: values.id,
      }

      simulatorApplicationService
        .createSimulatorApplication(newSimulatorApplication)
        .then((resp) => {
          dispatch(addSimulatorApplication(resp))
          setIsLoading(false)
          handleClose()
        })
        .catch((err) => {
          console.log(err)
          setIsLoading(false)
        })
    },
  })

  const handleClickOpen = () => {
    formik.resetForm()
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <Button variant="contained" onClick={handleClickOpen}>
        create simulator
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <form onSubmit={formik.handleSubmit}>
          <DialogTitle>Create Simulator Application</DialogTitle>
          <DialogContent>
            <DialogContentText>Please enter name for application.</DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Name"
              type="name"
              fullWidth
              variant="outlined"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
            <DialogContentText>(Optional) Enter the simulator Id.</DialogContentText>
            <TextField
              margin="dense"
              id="id"
              label="Simulator Id"
              type="name"
              fullWidth
              variant="outlined"
              value={formik.values.id}
              onChange={formik.handleChange}
              error={formik.touched.id && Boolean(formik.errors.id)}
              helperText={formik.touched.id && formik.errors.id}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Box sx={{ m: 1, position: "relative" }}>
              <Button type="submit" disabled={isLoading}>
                Create
              </Button>
              {isLoading && (
                <CircularProgress
                  size={24}
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </Box>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
